import React from "react";
import { Form } from "react-bootstrap";
import "./datepicker.css";

const TimePicker = ({ timeValue = "", scheduleInfo, setTimeValue }) => {
  return (
    <div className="new-custom-time">
      <Form.Group controlId="time">
        <Form.Control
          type="time"
          name="timePicker"
          className="shadow-none"
          placeholder="Select Time"
          value={timeValue}
          // disabled = {scheduleInfo.repeat !== "Never"? false : true}
          onChange={(e) => {
            const { value } = e.target;
            setTimeValue({ ...scheduleInfo, startTime: value });
          }}
        />
      </Form.Group>
    </div>
  );
};

export default TimePicker;
